"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import { RegularLinkButton } from "@/components/Button/RegularLinkButton/RegularLinkButton.component";
import { Translation } from "@/components/Translation/Translation.component";
import { useConversionTracking } from "@/hooks/tracking/conversion/use-conversion-tracking.hook";
import type { Locale } from "@/ts/locale/locale.types";
import type { ConversionEvent } from "@/vendors/Kilkaya/kilkaya.types";
type NewsletterSignUpSuccessBoxProps = {
  readonly conversionEvent?: ConversionEvent | null;
  readonly children?: React.ReactNode;
  readonly className?: string;
  readonly hasHomeButton: boolean;
};
export const newsletterSuccessMessage: Record<Locale, string> = {
  da: "Du er nu tilmeldt vores nyhedsbrev",
  de: "Sie sind jetzt für unseren Newsletter angemeldet.",
  en: "You are now subscribed to our newsletter.",
  no: "Du er nå påmeldt vårt nyhetsbrev",
  sv: "Du är nu prenumerant på vårt nyhetsbrev."
};
export function NewsletterSignUpSuccessBox(t0) {
  const $ = _c(11);
  const {
    conversionEvent: t1,
    children,
    className,
    hasHomeButton
  } = t0;
  const conversionEvent = t1 === undefined ? null : t1;
  useConversionTracking(conversionEvent);
  let t2;
  if ($[0] !== className) {
    t2 = clsx("min-h-[300px]", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Translation da="Du kan til enhver tid afmelde dig i bunden af det enkelte nyhedsbrev." de={"Sie k\xF6nnen sich jederzeit am Ende jedes Newsletters abmelden."} en="You can unsubscribe at any time at the bottom of each newsletter." no={"Du kan n\xE5r som helst melde deg av nederst i hvert nyhetsbrev."} sv={"Du kan n\xE4r som helst avsluta prenumerationen l\xE4ngst ner i varje nyhetsbrev."} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== hasHomeButton) {
    t4 = hasHomeButton ? <RegularLinkButton className="w-full md:max-w-md" href="/" position="nl-home-btn"><Translation da="Tilbage til forsiden" de={"Zur\xFCck zur Startseite"} en="Back to frontpage" no="Tilbake til forsiden" sv="Tillbaka till startsidan" /></RegularLinkButton> : null;
    $[3] = hasHomeButton;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="flex flex-col gap-4 py-2 md:max-w-lg">{t3}{t4}</div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== t2 || $[9] !== t5) {
    t6 = <div className={t2}>{children}{t5}</div>;
    $[7] = children;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}